import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DeviceService } from '../service/device.service';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PeriodicExecution } from '../model/periodicExecution';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AddPeriodicExecutionsComponent } from '../add-periodic-executions/add-periodic-executions.component';

@Component({
  selector: 'app-periodic-executions',
  templateUrl: './periodic-executions.component.html',
  styleUrls: ['./periodic-executions.component.css']
})
export class PeriodicExecutionsComponent implements OnInit {

  devices: DevicePilomat[] = [];
  devicesWithoutV123: DevicePilomat[] = [];
  devicesWithV123: string = "";

  periodicExecutions: PeriodicExecution[] = [];

  @ViewChild('periodicExecutionstable', { static: true }) table;
  @ViewChild('periodicExecutionsloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  @Input() filter: string;
  @Input() userCanExecutionEdit: boolean;

  warningString = $localize`:@@periodic_executions_dialog_warning:Attenzione`;


  displayedColumnsPeriodic: string[] = [
    'serial',
    'description',
    'daysAllowed',
    'hoursAllowed',
    'result',
    'deleteExecution'
  ];


  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay
  ) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.loader.showLoading();
    setTimeout(() => { this.getDevices(); }, 1000);
    // this.getDevices();
  }


  filterPeriodicTable(data: PeriodicExecution, filter: string): boolean {
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.description && data.description.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.result && data.result.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  onKey(event: any) {
    this.filter = event.target.value;
    this.table.dataSource.filter = this.filter.trim().toLowerCase();
  }

  getDevices() {
    this.loader.showLoading();

    this.deviceService.getDevices().subscribe(data => {

      for (let device of data) {
        // per la get degli automatismi
        this.devices.push(device);
        //                            <123
        if (device.systemInfo.version < DevicePilomat.MIN_VER_FORCEDLOW_REASON) {
          // da passare nel dialog di creazione
          this.devicesWithoutV123.push(device);
        } else {
          // da passare nel dialog di avviso
          this.devicesWithV123 += device.serial + ", ";
        }
      }

      if (this.devicesWithV123.length > 0) {
        this.devicesWithV123 = this.devicesWithV123.slice(0, -2);
      }

      this.cdRef.detectChanges();
      this.getPeriodicExecutions(0);

    });
  }

  addExecution() {
    if (this.devices.length == 0) {

      let message = $localize`:@@periodic_executions_dialog_no_compatible_devices:Non sono stati trovati dispositivi compatibili con gli automatismi, si prega di creare un'automazione`;
      let header = this.warningString;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '450px',
        data: { message, header },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
        }
      });

    } else {


      if (this.devicesWithV123.length > 0) {

        let message = $localize`:@@periodic_executions_dialog_found_v123_devices:Sono stati trovati dispositivi che non sono compatibili con gli automatismi, si prega di creare automazioni per questi. I loro seriali sono: :` + " " + this.devicesWithV123;
        let header = this.warningString;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '450px',
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {

          this.openAddExecutionDialog();

        });

      } else {

        this.openAddExecutionDialog();

      }
    }
  }


  openAddExecutionDialog() {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(AddPeriodicExecutionsComponent, {
      width: "1100px",
      data: { devices: this.devicesWithoutV123 },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Success") {
        let snackBarRef = this.snackBar.open($localize`:@@periodic_executions_creation_success:Automatismo creato con successo`, $localize`:@@periodic_executions_close:chiudi `, {
          duration: 3000
        });
        this.periodicExecutions = [];
        this.loader.showLoading();
        this.getPeriodicExecutions(0);
      } else if (result == "Error") {
        let snackBarRef = this.snackBar.open($localize`:@@periodic_executions_creation_error:Errore nella creazione degli automatismi`, $localize`:@@periodic_executions_close:chiudi `, {
          duration: 3000
        });
        this.loader.showError();
      }
    });
  }


  // editPeriodicExecution(execution: PeriodicExecution) {
  //   const scrollStrategy = this.overlay.scrollStrategies.reposition();
  //   const dialogRef = this.dialog.open(AddPeriodicExecutionsComponent, {
  //     width: "700px",
  //     data: { devices: this.devices, execution: execution },
  //     scrollStrategy,
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       if (result == "Success") {
  //         let snackBarRef = this.snackBar.open($localize`:@@periodic_executions_creation_success:Esecuzione creata con successo`, $localize`:@@periodic_executions_days_allowed  chiudi `, {
  //           duration: 3000
  //         });

  //       } else if (result == "Error") {
  //         let snackBarRef = this.snackBar.open($localize`:@@periodic_executions_creation_error:`, $localize`:@@periodic_executions_days_allowed  chiudi `, {
  //           duration: 3000
  //         });
  //       }
  //     }
  //   });

  // }

  getPeriodicExecutions(index: number) {
    if (index < this.devices.length) {
      const obs = this.deviceService.getPeriodicExecution(this.devices[index].serial);
      obs.subscribe(data => {
        for (let i = 0; i < data.length; i++) {
          this.periodicExecutions.push(data[i]);
        }
        this.getPeriodicExecutions(index + 1);

      }, error => {
        this.loader.hideLoading();
        this.loader.showError();
      });
    } else {
      this.table.dataSource = new MatTableDataSource(this.periodicExecutions);
      this.table.dataSource.filterPredicate = this.filterPeriodicTable;
      this.table.dataSource.sort = this.sort;

      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);
    }
  }


  deleteExecution(execution: PeriodicExecution) {
    let message = $localize`:@@periodic_executions_dialog_confirm:Desideri eliminare l'automatismo?`;
    let confirmMessage = $localize`:@@periodic_executions_dialog_confirm_yes:Sì, elimina`;
    let cancelMessage = $localize`:@@periodic_executions_dialog_confirm_no:No, annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.deviceService.deletePeriodicExecution(execution.serial, execution.id).subscribe((response) => {
          let snackBarRef = this.snackBar.open($localize`:@@periodic_executions_deletion_success:Automatismo eliminato con successo`, $localize`:@@periodic_executions_close:chiudi `, {
            duration: 3000
          });
          this.periodicExecutions = [];
          this.loader.showLoading();
          this.getPeriodicExecutions(0);
        }, (err) => {
          console.log(err);
        });
      }
    });
  }

  // deleteExecutions(index: number) {
  //   if (index < this.selectedDevices.length) {
  //     this.deviceService.deletePeriodicExecution(this.selectedDevices[index], this.periodicExecution.id).subscribe((response) => {
  //       this.deleteExecutions(index + 1);
  //     }, (err) => {
  //       console.log(err);
  //     });
  //   } else {
  //     this.dialogRef.close();
  //   }
  // }

}
